import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Calendar } from 'lucide-react';

const ranges = [
  { key: 'today', label: 'I dag' },
  { key: 'yesterday', label: 'I går' },
  { key: '7d', label: 'Siste 7 dager' },
  { key: '30d', label: 'Siste 30 dager' },
  { key: 'month', label: 'Denne måneden' },
  { key: 'all', label: 'All tid' },
];

export default function DateRangePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const current = ranges.find((r) => r.key === value) || ranges[2];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors shadow-sm"
      >
        <Calendar className="h-4 w-4 text-gray-400" />
        {current.label}
        <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50 py-1">
          {ranges.map((r) => (
            <button
              key={r.key}
              onClick={() => { onChange(r.key); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm transition-colors ${
                r.key === value
                  ? 'bg-emerald-50 text-emerald-700 font-medium'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
